import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-input-password',
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InputPasswordComponent {
  @Input() fieldValue: any;

  @Input() fieldText: string = '';

  @Input() inputLabel: string = '';

  @Input() labelClass: string = '';

  @Input() inputClass: string = '';

  @Input() inputPlaceholder: string = 'Password';

  @Input() fControl: FormControl<any> | any;

  @Input() patternValidationMsg: string = '';

  @Input() maxLengthValidationMsg: string = '';

  @Input() minLengthValidationMsg: string = '';

  @Input() customErrorValidationMsg: string = '';

  @Output()
  onTextChange = new EventEmitter<any>();

  @Output()
  onInputClick = new EventEmitter<any>();

  passwordVisible: boolean = false;

  sendData() {
    this.fieldValue = this.fControl.value;
    this.onTextChange.emit({ text: this.fieldText, value: this.fieldValue });
  }

  onClick(event: any) {
    this.onInputClick.emit(event);
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
}
